<template>
    <div id="mail-message">
        <div class="sc-message--text" @click="openModal">
            <span class="material-icons mail-icon">mail</span>
            <span>
                <span class="subject">
                    {{ message.raw.mail.subject }}
                </span>

                <div class="info" :style="{ width: message.raw.mail.body_text.length > 30 ? '26%' : '' }">
                    <span v-html="message.raw.mail.body_html" class="content"></span>
                </div>
            </span>
        </div>
        <VisitorDetailPopup v-if="visitorDetailPopup && visible" :visibleMail="true" />
    </div>
</template>

<script>
import store from "./../store/";
import { log2 } from "../../../utils/log2";
import { mapState, mapActions, mapMutations } from "vuex";
import GoogleIcon from "./../icons/GoogleIcon.vue";
import MailIcon from "./../icons/MailIcon.vue";

const log = log2("MailMessage");
import _ from "lodash";
import VisitorDetailPopup from "../../../views/Pages/Visitors/VisitorDetailPopup.vue";

export default {
    components: {
        VisitorDetailPopup,
        GoogleIcon,
        MailIcon,
    },
    data() {
        return {
            store,
            colors: ["#1BC5BD", "#725c31", "#3699FF", "#f64e60", "#bb71ff", "#FF7CC8", "#F4E151", "#7994C7", "#BA9292"],
            translating: false,
            translateOff: true,
            visible: false,
        };
    },
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            userName: (state) => (state.auth.user ? state.auth.user.name : ""),
            myLang: (state) => _.get(state.auth.user, "lang", "tr"),
            language: (state) => state.language.language,
            autoTranslate: (state) => state.chat.autoTranslate,
            settings: (state) => state.setting.settings,
            visitorDetailPopup: (state) => state.app.visitorDetailPopup,
        }),
    },
    methods: {
        ...mapActions({
            setVisitorDetailPopup: "app/setVisitorDetailPopup",
        }),
        ...mapMutations({
            USER_SELECTED_MAIL: "mail/USER_SELECTED_MAIL",
        }),
        openModal() {
            this.USER_SELECTED_MAIL(this.message.raw.mail.thread_id);
            this.visible = true;
            this.setVisitorDetailPopup(this.message.raw.mail.ref_visitor_id);
        },
    },
    mounted() {},
    watch: {
        visitorDetailPopup(val) {
            if (!val) {
                this.visible = false;
            }
        },
    },
};
</script>

<style lang="scss">
#mail-message {
    display: contents;

    .mail-icon {
        font-size: 40px;
        margin-right: 10px;
        color: #ffa800;
    }

    .subject {
        font-size: 16px;
        font-weight: 600;
        color: white !important;
    }

    .info {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        .content {
            font-size: 14px;
            color: white !important;
        }
    }

    .sc-message--text {
        color: white;
        background-color: #4e8cff;
        word-wrap: break-word;
        display: flex;
        font: 15px/20px Helvetica, Arial, sans-serif;
        align-items: center;
        padding: 5px;
        width: 30%;
    }

    .mail-message-container {
        background: #ffffff;
        display: flex;
        border-radius: 50%;
        padding: 5px;
        margin-right: 5px;
    }
}
</style>
